var _module_exports = "<div>\n  <rzslider rz-slider-options=\"$ctrl.options\" rz-slider-model=\"$ctrl.model\"></rzslider>\n</div>\n";;
var path = 'app/core/components/slider/slider.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;